import * as React from 'react'
import { Link } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import type CalendarEvent from 'modules/calendar/store/models/CalendarEvent'

import * as styles from './index.vanilla.css'

interface Props {
  event: CalendarEvent
}

const PostEvent = ({ event }: Props) => {
  const { navigation } = useNavigation()

  return (
    <Link
      className={styles.link}
      to={navigation.dashboard.post.id.fullPath({ id: event.metadata('id') })}
    >
      <span>{event.metadata('title')}</span>
    </Link>
  )
}

export default PostEvent
